import React, { Component } from "react";
import { Link } from "react-router-dom";
import styles from "../Navbar/Navbar.module.scss";
import { HashLink } from "react-router-hash-link";
// import PropTypes from "prop-types";

export class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      colorChange: false,
    };
    this.myFunction = this.myFunction.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.changeNavbarColor);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.changeNavbarColor);
  }

  myFunction() {
    console.log("button click");
    this.setState((prevState) => ({
      showMenu: !prevState.showMenu,
    }));
  }

  changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      this.setState({
        colorChange: true,
      });
    } else {
      this.setState({
        colorChange: false,
      });
    }
  };
  render() {
    return (
      <div>
        <header>
          {/* <div className="top-info">
            <div className="container">
              <div className="info">
                <img
                  src="https://www.bmgrandhotelandresort.com/images/best-rate.svg"
                  alt=""
                />
                <div className="phone">
                  <i className="fa fa-phone">Font Office - 9102994158</i>
                </div>
              </div>
            </div>
          </div> */}
          {/* THis is main navbar */}

          <nav
            className={`${styles.main_navbar} ${
              this.state.colorChange ? styles.colorChange : ""
            }`}
          >
            <div className="container">
              <div className={styles.navbar_}>
                <div className={styles.logo}>
                  <a href="/">
                    <img src="../assets/logo_25.png" alt="" />
                  </a>
                </div>
                <div className={styles.navbar_menu}>
                  <ul>
                    <li className={styles.nav_item}>
                      <Link to="/" className={styles.nav_link}>
                        Home
                      </Link>
                    </li>
                    <li className={styles.nav_item}>
                      <HashLink to="/#about" smooth className={styles.nav_link}>
                        About
                      </HashLink>
                    </li>
                    <li className={styles.nav_item}>
                      <HashLink to="/#rooms" smooth className={styles.nav_link}>
                        Rooms
                      </HashLink>
                    </li>
                    <li className={styles.nav_item}>
                      <HashLink
                        smooth
                        to="/#gllary"
                        className={styles.nav_link}
                      >
                        Gallery
                      </HashLink>
                    </li>
                    <li className={styles.nav_item}>
                      <HashLink
                        to="/#service"
                        smooth
                        className={styles.nav_link}
                      >
                        Services
                      </HashLink>
                    </li>

                    <li className={styles.nav_item}>
                      <Link to="contact" className={styles.nav_link}>
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>
        </header>

        {/* This is Mobile Name */}
        <nav className={styles.mobile_nav}>
          <div className="container">
            <div className={styles.nav_bar}>
              <div className={styles.logo}>
                <Link to="">
                  <img src="assets/logo_25.png" alt="" />
                </Link>
              </div>
              <div className={styles.toggle_button}>
                <button
                  onClick={this.myFunction}
                  className={this.state.showMenu ? styles.menuicons : ""}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </button>
              </div>
            </div>
          </div>
        </nav>

        {/* {this.state.showMenu && ( */}
        <nav
          className={`${styles.toggle_menu}  ${
            this.state.showMenu ? styles.actives : ""
          }`}
        >
          <div className={styles.menus}>
            <ul className={styles.navbar_nav}>
              <li className={styles.nav_item}>
                <Link
                  to="/"
                  onClick={this.myFunction}
                  className={
                    this.state.showMenu ? styles.menuicons : "nav_link"
                  }
                >
                  Home
                </Link>
              </li>
              <li className={styles.nav_item}>
                <HashLink
                  onClick={this.myFunction}
                  className={
                    this.state.showMenu ? styles.menuicons : "nav_link"
                  }
                  smooth
                  to="/#about"
                >
                  About
                </HashLink>
              </li>
              <li className={styles.nav_item}>
                <HashLink
                  smooth
                  to="/#rooms"
                  onClick={this.myFunction}
                  className={
                    this.state.showMenu ? styles.menuicons : "nav_link"
                  }
                >
                  Rooms
                </HashLink>
              </li>
              <li className={styles.nav_item}>
                <HashLink
                  smooth
                  to="/#gllary"
                  onClick={this.myFunction}
                  className={
                    this.state.showMenu ? styles.menuicons : "nav_link"
                  }
                >
                  Gallery
                </HashLink>
              </li>
              <li className={styles.nav_item}>
                <HashLink
                  smooth
                  to="/#service"
                  onClick={this.myFunction}
                  className={
                    this.state.showMenu ? styles.menuicons : "nav_link"
                  }
                >
                  Services
                </HashLink>
              </li>

              <li className={styles.nav_item}>
                <Link
                  to="contact"
                  onClick={this.myFunction}
                  className={
                    this.state.showMenu ? styles.menuicons : "nav_link"
                  }
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}

export default Navbar;
